import { render, staticRenderFns } from "./WPTextInfoLine.vue?vue&type=template&id=486ecb8e"
import script from "./WPTextInfoLine.vue?vue&type=script&lang=ts"
export * from "./WPTextInfoLine.vue?vue&type=script&lang=ts"
import style0 from "./WPTextInfoLine.vue?vue&type=style&index=0&id=486ecb8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports